import { MergeAccountProfileBreadCrumb } from './merge-account';

export const MergeAccountProfileBreadCrumbs: MergeAccountProfileBreadCrumb = {
    uprageKYCLevel2: {
        title: 'Level 2 Upgrade',
        url: '/onboarding-v2/kyc-lvl2',
    },
    brmUprageKYCLevel2: {
        title: 'BRM Level 2 Upgrade',
        url: '/onboarding-v2/brm-kyc-lvl2',
    },
    boDashboard: {
        title: 'Bo Dashboard',
        url: '/main-app/business-user/dashboard',
    },
    brmDashboard: {
        title: 'BRM Dashboard',
        url: '/main-app/aggregator/brm-dashboard-v2/view',
    },
};
